<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="for"><a id="page_vii"></a><a href="#/xhtml/foreword#for"><i>Foreword by</i> Justo L. González</a></p>
<p class="Toc" id="pre"><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc" id="abb"><a href="#/xhtml/abbreviations#abb">Abbreviations</a></p>
<p class="Toc1" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.<span class="space1">Latino Protestantism Today</span></a></p>
<p class="Toc1" id="ch-002"><a href="#/xhtml/chapter002#ch002">2.<span class="space1">Framing the Latino Protestant Story</span></a></p>
<p class="Toc1" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space1">Conquest, Americanization, and Evangelization (1848–1900)</span></span></p>
<p class="Toc1" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">Ministry among the “Northern Mexicans” (1901–1940)</span></span></p>
<p class="Toc1" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">Migrant Workers, Citizens, and Exiles (1941–1964)</span></span></p>
<p class="Toc1" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space1">New Faces among Latino Protestants (1965–1985)</span></span></p>
<p class="Toc1" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space1">Latino Protestants Are Finally “Discovered” (1986–2000)</span></span></p>
<p class="Toc1" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8.<span class="space1">Finding a Place at the Table (2001–Present)</span></span></p>
<p class="Toc1" id="ch-009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample">9.<span class="space1">Futures of Latino Protestantism</span></span></p>
<p class="Toc" id="ch-010"><span href="#/xhtml/chapter010#ch010" title="Link target outside of Sample">Concluding Thoughts on a Living History</span></p>
<p class="Toc" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Works Cited</span></p>
<p class="Toc" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7890bb6f